import * as angular from "angular";
import {IController} from "angular";

export class selfPickupTypeIconCtrl implements IController {

  type: any;

  /* @ngInject */
  constructor() {
  }

}

angular
  .module('bringoz.admin.self-pickups')
  .component('selfPickupTypeIcon', {
    bindings: {
      type: '<'
    },
    template: require('./self-pickup-type-icon.html').default,
    controller: selfPickupTypeIconCtrl
  });
